export const formatFullName = profile => `${profile.firstName} ${profile.lastName}`;

export const formatPhoneNumberForExcel = phone => {
  const phoneWithoutSigns = Boolean(phone) ? `${phone.replace(/[\D]+/g, '')}` : '';

  if (phoneWithoutSigns.startsWith('0')) {
    return phoneWithoutSigns.slice(1)
  } else if (phoneWithoutSigns.startsWith('972')) {
    return phoneWithoutSigns.slice(3);
  } else return phoneWithoutSigns;
};
